import { useRef } from "react";
import { motion } from "framer-motion";
import { useLang } from "../../lib/lang";
import { SectionHead, EASE } from "./Reveal";

const ReelCard = ({ src, cap, i, testid }) => {
  const ref = useRef(null);
  return (
    <motion.figure
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay: i * 0.15, ease: EASE }}
      className="group relative rounded-[24px] overflow-hidden border border-white/10 bg-[#13182E]"
      onMouseEnter={() => ref.current?.play()}
      onMouseLeave={() => ref.current?.pause()}
    >
      <video
        ref={ref}
        data-testid={testid}
        src={src}
        autoPlay
        muted
        loop
        playsInline
        className="w-full aspect-video object-cover transition-transform duration-[1.4s] group-hover:scale-[1.04]"
      />
      <div className="absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-[#0B0E1B]/95 to-transparent">
        <span className="font-mono text-[11px] uppercase tracking-widest text-sky-300">TIMELAPSE 0{i + 1}</span>
        <figcaption className="font-display text-xl text-white mt-1">{cap}</figcaption>
      </div>
    </motion.figure>
  );
};

export const Reel = () => {
  const { t } = useLang();
  return (
    <section id="reel" className="relative bg-[#0D1124] border-y border-white/10">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-24 lg:py-32">
        <SectionHead eyebrow={t.reelEyebrow} title={t.reelTitle} testid="reel-title" />
        <div className="grid md:grid-cols-2 gap-5 lg:gap-6">
          <ReelCard src="/video/v1.mp4" cap={t.reelCaps[0]} i={0} testid="reel-video-1" />
          <ReelCard src="/video/v2.mp4" cap={t.reelCaps[1]} i={1} testid="reel-video-2" />
        </div>
      </div>
    </section>
  );
};
